// Bermuda transportation data — update this ONE file when services, fares or rules change.

export const SHORELINK = {
  name: "Shorelink",
  url: "https://shorelink.bm/",
  blurb: "Bermuda's digital companion for public transport — digital bus and ferry fares, routes and transport information in one place.",
};

export const TRANSPORT = {
  taxi: {
    name: "Taxi",
    icon: "car",
    tagline: "Best for door-to-door ease",
    whyBase: "Nothing in Bermuda is simpler than a taxi: door-to-door, no schedules, no parking, no left-side driving.",
    goodToKnow: [
      "The strongest choice for airport transfers, luggage and important timed journeys",
      "Ideal for groups — the fare is shared, not per person",
      "Perfect for dinner reservations and evenings out",
      "Available for private sightseeing by the hour",
    ],
    bestFor: ["Airport transfers", "Groups", "Luggage", "Door-to-door convenience", "Private sightseeing", "Dinner & nightlife"],
  },
  rideshare: {
    name: "Regulated Ride Share",
    icon: "smartphone",
    tagline: "Best for app-based flexibility",
    whyBase: "Bermuda introduced regulated ride sharing in June 2026 — app-based, cashless, point-to-point transport operating alongside traditional taxis.",
    goodToKnow: [
      "Regulated ride sharing launched in Bermuda in June 2026",
      "Operates alongside — not instead of — Bermuda's traditional taxis",
      "App-based requests and cashless payment",
      "Well suited to solo travellers, couples and evening trips",
    ],
    bestFor: ["App-based transport", "Cashless requests", "Point-to-point trips", "Evening transportation", "Flexible travel"],
  },
  bus: {
    name: "Bermuda Bus",
    icon: "bus",
    tagline: "Best for budget exploring",
    whyBase: "Bermuda's public buses are the affordable way to explore the island — pink-striped, frequent on main routes, and genuinely part of the Bermuda experience.",
    goodToKnow: [
      "Pink bus-stop poles generally indicate travel toward Hamilton; blue poles, away from Hamilton",
      "The most affordable way to reach beaches and attractions",
      "Best in daylight hours — service thins out in the evening",
      "Use Shorelink for digital fares, routes and schedules",
    ],
    bestFor: ["Budget travellers", "Beaches", "Attractions", "Daytime exploring", "Visitors happy to follow schedules"],
  },
  ferry: {
    name: "Bermuda Ferry",
    icon: "ship",
    tagline: "Best for the experience itself",
    whyBase: "The ferry is transportation and a Bermuda experience in one — harbour views, sea air, and the most civilised way between Hamilton and the West End.",
    goodToKnow: [
      "Particularly useful for harbour and West End (Dockyard) journeys",
      "Schedules can change seasonally — always check the current timetable",
      "Use Shorelink for digital fares and transport information",
      "Arrive a few minutes early; ferries run to time",
    ],
    bestFor: ["Scenic travel", "Harbour journeys", "Hamilton", "Dockyard", "Making the journey part of the vacation"],
  },
  microcar: {
    name: "Electric Microcar",
    icon: "zap",
    tagline: "Best for independent exploring",
    whyBase: "Visitors can't rent conventional full-size cars in Bermuda the way they can elsewhere — compact electric microcars are the island's answer: your own wheels, on your own schedule.",
    goodToKnow: [
      "Bermuda drives on the LEFT",
      "Available from Bermuda rental providers — book ahead in season",
      "Ideal for couples and solo travellers; seating is limited",
      "Freedom to beach-hop and explore on your own timetable",
    ],
    bestFor: ["Couples", "Solo travellers", "Independent exploring", "Beach hopping", "Flexible itineraries"],
  },
};

export const QUIZ_QUESTIONS = [
  {
    id: "priority",
    title: "What matters most to you?",
    options: [
      { label: "Keeping costs down", sub: "I'm happy to plan around routes and schedules.", scores: { bus: 3, ferry: 2 } },
      { label: "Easy & door-to-door", sub: "I want the simplest option with minimal walking.", scores: { taxi: 3, rideshare: 3 } },
      { label: "The experience", sub: "I want the journey to feel like part of my Bermuda vacation.", scores: { ferry: 3, microcar: 1 } },
      { label: "Freedom to explore", sub: "I want to go wherever I want, whenever I want.", scores: { microcar: 4 } },
    ],
  },
  {
    id: "journey",
    title: "What kind of journey are you planning?",
    options: [
      { label: "Airport / luggage", sub: "Arriving, departing or travelling with bags.", scores: { taxi: 4, rideshare: 1 } },
      { label: "Dinner or nightlife", sub: "I want an easy ride out and back.", scores: { taxi: 3, rideshare: 3 } },
      { label: "Beaches & attractions", sub: "I'll be visiting different places around Bermuda.", scores: { bus: 2, microcar: 3 } },
      { label: "Hamilton / Dockyard", sub: "I'm travelling around the harbour or West End.", scores: { ferry: 4, bus: 1 } },
      { label: "Full island adventure", sub: "I want to explore several areas in one day.", scores: { microcar: 4 } },
    ],
  },
  {
    id: "party",
    title: "How many people are travelling together?",
    options: [
      { label: "Just me", sub: "", scores: { bus: 2, microcar: 2, rideshare: 2 } },
      { label: "2 people", sub: "", scores: { microcar: 2, rideshare: 2 } },
      { label: "3–4 people", sub: "", scores: { taxi: 1 } },
      { label: "5+ people", sub: "", scores: { taxi: 4, microcar: -4 } },
    ],
  },
  {
    id: "driving",
    title: "Are you comfortable driving in Bermuda?",
    options: [
      { label: "Yes", sub: "I'm comfortable driving on the left and navigating Bermuda's roads.", scores: { microcar: 4 } },
      { label: "No thanks", sub: "I'd rather let someone else do the driving.", scores: { taxi: 2, rideshare: 2, microcar: -5 } },
    ],
  },
  {
    id: "schedule",
    title: "How flexible do you want your schedule to be?",
    options: [
      { label: "Schedules are fine", sub: "I don't mind planning around departure times.", scores: { bus: 2, ferry: 2 } },
      { label: "Very flexible", sub: "I want to leave whenever I'm ready.", scores: { taxi: 2, rideshare: 2, microcar: 2 } },
    ],
  },
  {
    id: "timing",
    title: "When will you travel most?",
    options: [
      { label: "Mostly daytime", sub: "Sightseeing, beaches, shopping and daytime activities.", scores: { bus: 2, ferry: 2, microcar: 1 } },
      { label: "Evenings too", sub: "Restaurants, events, nightlife and later returns.", scores: { taxi: 3, rideshare: 3 } },
    ],
  },
];

export const track = (event, props) => {
  try { window.posthog?.capture(event, props); } catch (e) { /* analytics optional */ }
};
